import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { authAPI, SESSION_TOKEN_KEY } from '../utils/api';
import { useAuth } from '../contexts/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { updateUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    if (hasProcessed.current) {
      console.log('[AuthCallback] Already processed, skipping');
      return;
    }
    hasProcessed.current = true;

    const processSession = async () => {
      console.log('[AuthCallback] Processing session. Hash:', window.location.hash);
      console.log('[AuthCallback] Full URL:', window.location.href);
      
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      console.log('[AuthCallback] Session ID found:', sessionId ? 'yes' : 'no');

      if (!sessionId) {
        console.log('[AuthCallback] No session_id in hash, redirecting to login');
        navigate('/login');
        return;
      }

      try {
        console.log('[AuthCallback] Exchanging session...');
        // Silent backoff on the login handshake itself: if the server is
        // queueing logins (429) or momentarily slow (timeout), retry
        // quietly (1s, 3s) instead of bouncing the student to /login.
        let response = null;
        let lastError = null;
        const delays = [0, 1000, 3000];
        for (let attempt = 0; attempt < delays.length; attempt++) {
          if (delays[attempt]) await new Promise(r => setTimeout(r, delays[attempt]));
          try {
            response = await authAPI.exchangeSession(sessionId);
            break;
          } catch (err) {
            lastError = err;
            const status = err?.response?.status;
            const retryable = !err.response || status === 429 || status >= 500;
            if (!retryable) throw err;
          }
        }
        if (!response) throw lastError;
        const { session_token, ...user } = response.data;
        console.log('[AuthCallback] Session exchange success! User:', user.email, 'Role:', user.role);

        // Persist token in LocalStorage: every API call now authenticates
        // via Authorization header (immune to cookie blocking)
        if (session_token) {
          try {
            localStorage.setItem(SESSION_TOKEN_KEY, session_token);
          } catch (e) { /* localStorage unavailable */ }
        }

        // Update global auth state
        updateUser(user);

        // Check if user has role
        if (!user.role) {
          navigate('/role-select', { state: { user }, replace: true });
        } else if (user.role === 'admin') {
          navigate('/admin', { state: { user }, replace: true });
        } else if (user.role === 'teacher') {
          navigate('/teacher/dashboard', { state: { user }, replace: true });
        } else {
          navigate('/student/dashboard', { state: { user }, replace: true });
        }
      } catch (error) {
        console.error('[AuthCallback] Session exchange FAILED:', error?.response?.status, error?.response?.data, error?.message);
        navigate('/login');
      }
    };

    processSession();
  }, [navigate, updateUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-4 border-primary mx-auto"></div>
        <p className="mt-4 text-slate-600 font-nunito">Autenticando...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
